import { render, staticRenderFns } from "./RoomsForm.vue?vue&type=template&id=6a48110d"
import script from "./RoomsForm.vue?vue&type=script&lang=js"
export * from "./RoomsForm.vue?vue&type=script&lang=js"
import style0 from "./RoomsForm.vue?vue&type=style&index=0&id=6a48110d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports